import PropTypes from "prop-types";
import React from "react";
import Info from "./Info";
import Notification from "./Notification";
import QuotaLimit from "./quota/QuotaLimit";
import CollectionSelect from "./CollectionSelect";
import { Box, Flex, Image, Text, useMantineTheme } from "@mantine/core";
import CustomAnchor from "./mantineCustomComponents/CustomAnchor";
import { useStylesGeneral } from "../utils/mantine/stampTabContent/useStylesGeneral";
import CustomButton from "./mantineCustomComponents/CustomButton";
import TipTapEditor from "./user-profile/TipTapEditor";
import ValidationError from "./ValidationError";

const StampFromText = ({
  currentScreen,
  staticBasePath,
  text,
  setText,
  handleTextToFile,
  handleRemoveText,
  isSmallScreen,
  isAuthenticated,
  button,
  buttonStampClassName,
  noQuotaAvailable,
  helpIsActive,
  onSelectedOptionCollection,
  selectedOptionCollection,
  activateSelectCollection,
  onActivateSelectCollection,
  selectCollections,
  textPortfolioValidation,
}) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  // css classes
  const { classes: GeneralClasses } = useStylesGeneral();
  return (
    <>
      <Box
        id="verify-method-hash__screen"
        className={`${GeneralClasses.wrap} stamp-text-wrap`}
      >
        <Box
          className={`${GeneralClasses.wrapContent} ${GeneralClasses.stampFromTextContainer}`}
        >
          {currentScreen === "found" && (
            <Info
              textInfo="You have already stamped this file previously. You can choose another file or stamp this content ID again."
              staticBasePath={staticBasePath}
            />
          )}
          <Box className={GeneralClasses.stampFromHashContainer}>
            {!isAuthenticated && <Notification />}
            {noQuotaAvailable && <QuotaLimit />}

            <TipTapEditor
              placeholder="Input Text"
              value={text}
              editable={isAuthenticated}
              onChange={(event) => setText(event)}
              disabled={!isAuthenticated}
              styles={() => ({
                root: {
                  zIndex: !isAuthenticated ? "-1" : "",
                  position: !isAuthenticated ? "relative" : "",
                },
              })}
            />

            <ValidationError validation={textPortfolioValidation} />

            {text && (
              <Image
                onClick={handleRemoveText}
                src={`${staticBasePath}public/images/svg/rb-remove-hash.svg`}
                alt="Remove Text"
                className={GeneralClasses.stampFromHashInputImg}
              />
            )}

            {isSmallScreen && (
              <Box className={GeneralClasses.stampInfo}>
                <CustomButton
                  text="Make a vBase Stamp!"
                  className={buttonStampClassName}
                  onClick={() => handleTextToFile()}
                  disabled={
                    !button ||
                    !text ||
                    !textPortfolioValidation.isValid ||
                    (!selectedOptionCollection &&
                      activateSelectCollection === true)
                  }
                  componentClasses={buttonStampClassName}
                />

                {!isAuthenticated && (
                  <Box className={GeneralClasses.stampHashMobileLogin}>
                    <CustomAnchor
                      text="Sign In"
                      href="/accounts/login/"
                      componentClasses="link"
                    />
                    <Text component="span"> to Start Stamping!</Text>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Box className={GeneralClasses.stampFromHashContainer}>
        <Flex
          justify={theme.flex.justify.center}
          align={theme.flex.align.center}
          className={`${GeneralClasses.stampHashText} ${GeneralClasses.stampHashTextFirst} `}
        >
          <Image
            src={`${staticBasePath}public/images/svg/rb-info-grey.svg`}
            alt="Info"
          />
          <Text className="rb-method-hash-text">
            Stamped Text will be saved in your account’s private folder. To
            download locally, see{" "}
            <CustomAnchor
              text="Stamped File Storage"
              href="/profile/#user_data_storage"
              componentClasses="link"
            />
            .
          </Text>
        </Flex>

        {selectCollections && isAuthenticated && (
          <CollectionSelect
            activateSelectCollection={activateSelectCollection}
            onActivateSelectCollection={onActivateSelectCollection}
            onActivateSelectBCollection={onActivateSelectCollection}
            selectCollections={selectCollections}
            onSelectedOptionCollection={onSelectedOptionCollection}
            selectedOptionCollection={selectedOptionCollection}
            helpIsActive={helpIsActive}
          />
        )}
      </Box>
    </>
  );
};
StampFromText.propTypes = {
  text: PropTypes.string.isRequired,
  setText: PropTypes.func.isRequired,
  currentScreen: PropTypes.string.isRequired,
  staticBasePath: PropTypes.string.isRequired,
  handleTextToFile: PropTypes.func.isRequired,
  handleRemoveText: PropTypes.func.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  button: PropTypes.bool.isRequired,
  handleCreateSubmit: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  buttonStampClassName: PropTypes.string.isRequired,
  noQuotaAvailable: PropTypes.bool.isRequired,
  onSelectedOptionCollection: PropTypes.func.isRequired,
  selectedOptionCollection: PropTypes.object,
  activateSelectCollection: PropTypes.bool.isRequired,
  onActivateSelectCollection: PropTypes.func.isRequired,
  helpIsActive: PropTypes.bool.isRequired,
  selectCollections: PropTypes.array,
  textPortfolioValidation: PropTypes.object,
};
export default StampFromText;
